import * as React from 'react';
import { Row } from 'react-bootstrap';
import type { WrappedFieldArrayProps } from 'redux-form';

import type { W_Equipment_FindAllForCompanyList_VM } from 'ab-api/web/equipment/findAllForCompanyList';

import { Button } from '@acceligentllc/storybook';

import ReportBlock from './Block';
import type { ReportBlockFieldFormModel } from '../formModel';

export interface OwnProps {
	filterVisibleToCustomer: boolean;
	formValues?: Record<string, string>[];
	highlightVisibleToCustomer?: boolean;
	onCalculatedFieldChange: (id: string) => void;
	onFieldValueChange?: (id: string, value: string, index: number) => void;
	onRemoveRepeatableFields?: (index: number) => void;
	reportBlockFieldIds: Nullable<string[]>;
	reportFieldsByIdMap: { [id: string]: ReportBlockFieldFormModel; };
	listOfEquipment?: Nullable<W_Equipment_FindAllForCompanyList_VM>;
}

type Props = OwnProps & WrappedFieldArrayProps;

const BlockArray: React.FC<Props> = (props: Props) => {

	const {
		fields,
		onRemoveRepeatableFields,
		reportBlockFieldIds,
		highlightVisibleToCustomer,
		onFieldValueChange,
		onCalculatedFieldChange,
		formValues,
		filterVisibleToCustomer,
		reportFieldsByIdMap,
		listOfEquipment,
	} = props;

	const add = React.useCallback(() => fields.push({}), [fields]);

	const getRemoveFor = React.useCallback((index: number) => {
		return () => {
			onRemoveRepeatableFields?.(index);
			fields.remove(index);
		};
	}, [fields, onRemoveRepeatableFields]);

	const renderField = React.useCallback((_field: string, _index: number) => {
		return (
			<div className="report-block__array" key={_field}>
				<ReportBlock
					filterVisibleToCustomer={filterVisibleToCustomer}
					formField={_field}
					formValues={formValues}
					highlightVisibleToCustomer={highlightVisibleToCustomer}
					index={_index}
					listOfEquipment={listOfEquipment}
					onCalculatedFieldChange={onCalculatedFieldChange}
					onFieldValueChange={onFieldValueChange}
					reportBlockFieldIds={reportBlockFieldIds}
					reportFieldsByIdMap={reportFieldsByIdMap}
				/>
				<Button
					icon="Delete"
					onClick={getRemoveFor(_index)}
					style="link-danger"
					tooltip="Delete"
				/>
			</div>
		);
	}, [
		reportBlockFieldIds,
		filterVisibleToCustomer,
		reportFieldsByIdMap,
		getRemoveFor,
		highlightVisibleToCustomer,
		onCalculatedFieldChange,
		onFieldValueChange,
		formValues,
		listOfEquipment,
	]);

	React.useEffect(() => {
		if (!fields.length) {
			add();
		}
	}, [add, fields]);

	return (
		<>
			<Row className="row--non-padded">
				{fields.map(renderField)}
			</Row>
			<Button
				icon="ActionPlusSmall"
				label="Add"
				onClick={add}
				style="link"
			/>
		</>
	);
};

export default React.memo(BlockArray);
